import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme/theme';

export default function PageHeader({ title, subtitle, action }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', mb: 3 }}>
      <Box>
        <Typography variant="h5" sx={{ color: tokens.text.primary }}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: tokens.text.secondary, mt: 0.5 }}>{subtitle}</Typography>
        )}
      </Box>
      {action}
    </Box>
  );
}
